import Default from "./DisplayProperties";
export * from "./DisplayProperties";
export default Default;
